
import { React, Fragment, useState, useEffect, useContext, useRef, useCallback, useMemo, useLayoutEffect } from 'react'
import { Button } from 'bootstrap'
import "../css/PagesCommonStyle.css"
import { faL, faMagnifyingGlass, faPrint, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf } from '@fortawesome/free-regular-svg-icons'
import { useSelector } from 'react-redux';
import { faTriangleExclamation, faStar, faCircleInfo, faXmark, faPlus, faMinus, faPencil, faFloppyDisk } from '@fortawesome/free-solid-svg-icons'
import { APIConstants, CommonAPIConstants, EditCPTConstants, MacroConstants } from '../utilities/Constants'
import Draggable from 'react-draggable'
import * as XLSX from 'xlsx';
import { useParams, useLocation, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import { counter, parse } from '@fortawesome/fontawesome-svg-core'
import DatePicker from 'react-datepicker';
import { format, set } from 'date-fns';




const EditCpt = () => {

    const navigate = useNavigate();



    const userData = useSelector((state) => state.user.user);

    localStorage.setItem('userData', JSON.stringify(userData));

    const { id } = useParams();

    const location = useLocation();

    const { state } = useLocation();



    const data = state?.claimDetails ? JSON.stringify(state.claimDetails) : "{}";
    const claimData = state?.claimDetails ? JSON.parse(state.claimDetails) : {};

    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;

    const sAuthToken = useSelector((state) => state.user.token);

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Default value for the input is the current date
    const defaultDate = getCurrentDate();
    const defaultFromDate = new Date('2015-01-01');

    const [error, setError] = useState(null);
    const [startDate, setStartDate] = useState(''); // State to store start date
    const [endDate, setEndDate] = useState('');     // State to store end date
    const [loading, setLoading] = useState(true);

    const [appointmentDate, setAppointmentDate] = useState('');

    const [selectedCMS33a, setSelectedCMS33a] = useState('');
    const [selectedCMS33b, setSelectedCMS33b] = useState('');
    const [selectedBillingNPI, setSelectedBillingNPI] = useState('');
    const [selectedService, setSelectedService] = useState('');

    const [cms33aData, setCMS33aData] = useState([]);
    const [cms33bData, setCMS33bData] = useState([]);

    const [tableDetails, setTableDetails] = useState([]);



    const [patientList, setPatientList] = useState('');
    const [hasFetched, setHasFetched] = useState(false);

    const [selectedCPTCode, setSelectedCPTCode] = useState([]);



    const [searchByCPT, setSearchByCPT] = useState('');
    const [searchByDescription, setSearchByDescription] = useState('');
    const [searchByFee, setSearchByFee] = useState('');
    const [searchByCharges, setSearchByCharges] = useState('');
    const [searchByGroup, setSearchByGroup] = useState('');

    const [searchByService, setSearchByService] = useState('');
    const [searchByBox32a, setSearchByBox32a] = useState('');
    const [searchByBox33a, setSearchByBox33a] = useState('');
    const [searchByBox33b, setSearchByBox33b] = useState('');

    const [selectedCptValue, setSelectedCptValue] = useState('');

    const [isSuggestionSelected, setIsSuggestionSelected] = useState(false);

    const [cptValueList, setCptValueList] = useState([]);

    const [selectedUnitValue, setSelectedUnitValue] = useState('');

    const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [showApprovalSaveModal, setShowApprovalSaveModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [showPaidErrorModal, setShowPaidErrorModal] = useState(false);
    const [closeClaimsModal, setCloseClaimsModal] = useState(false);
    const [showFaxModal, setShowFaxModal] = useState(false);

    const [successTimer, setSuccessTimer] = useState(5000);


    const [errorMessage, setErrorMessage] = useState(false);


    const [syncedValue, setSyncedValue] = useState('');
    const [syncedUnitchargeVal, setSyncedUnitchargeVal] = useState('');

    const [activeRow, setActiveRow] = useState(null);

    const [cptdescription, setCptDescription] = useState('');
    const [filteredTableDetails, setFilteredTableDetails] = useState(tableDetails);

    /**
     * Render the fee schedule 200 rows at a time.
     *
     * This table was mapping the practice's entire CPT list in one pass, and
     * every row carries a toggle switch plus several inputs. On a full schedule
     * that is tens of thousands of DOM nodes built synchronously, which is what
     * left Chrome sitting at "Not Responding" on this page. Same windowing the
     * other long tables in this app already use.
     */

    // ─────────────────────────────────────────────────────────────────────
    // UI-only state for the redesign. None of it reaches an API: every fetch,
    // payload and handler below is untouched. These drive presentation and
    // client-side filtering of data that has already been loaded.
    // ─────────────────────────────────────────────────────────────────────

    // Column widths in one place. This array feeds both the <colgroup> and the
    // --hv-pin-N custom properties, so the frozen block and the columns are
    // physically incapable of disagreeing.
    const COLS = useMemo(() => ([
        { key: 'index',   w: 56  },
        { key: 'cpt',     w: 120 },
        { key: 'desc',    w: 280 },
        { key: 'fee',     w: 130 },
        { key: 'charges', w: 130 },
        { key: 'group',   w: 170 },
        { key: 'service', w: 150 },
        { key: 'box32a',  w: 190 },
        { key: 'box33a',  w: 200 },
        { key: 'box33b',  w: 200 },
        { key: 'unit',    w: 110 },
        { key: 'action',  w: 100 },
    ]), []);

    /**
     * How far down the viewport this page starts, for
     * `height: calc(100dvh - var(--hv-top))`. Measured, not hardcoded: the
     * global header re-wraps to a second row as the window narrows.
     */
    const [hvTop, setHvTop] = useState(0);

    useLayoutEffect(() => {
        if (typeof window === 'undefined') return undefined;
        let frame = 0;
        const measure = () => {
            frame = 0;
            const nav = document.querySelector('.nav-container');
            const next = nav ? Math.round(nav.getBoundingClientRect().bottom + window.scrollY) : 0;
            setHvTop((prev) => (prev === next ? prev : next));
        };
        const schedule = () => { if (!frame) frame = window.requestAnimationFrame(measure); };
        measure();
        window.addEventListener('resize', schedule);
        const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(schedule) : null;
        if (ro) ro.observe(document.body);
        return () => {
            if (frame) window.cancelAnimationFrame(frame);
            window.removeEventListener('resize', schedule);
            if (ro) ro.disconnect();
        };
    }, []);

    const [addOpen, setAddOpen] = useState(false);
    const addCodeRef = useRef(null);

    const [tab, setTab] = useState('all');
    const [groupFilter, setGroupFilter] = useState('');
    const [serviceFilter, setServiceFilter] = useState('');
    const [chargeFilter, setChargeFilter] = useState('all');
    const [dirtyCount, setDirtyCount] = useState(0);

    const markDirty = useCallback(() => setDirtyCount((n) => n + 1), []);

    // A select still sitting on its placeholder. With forty on screen, one that
    // was never set looks exactly like one that was.
    const isUnset = useCallback(
        (v) => v === undefined || v === null || v === '' || String(v) === '-1' || String(v) === '0',
        [],
    );


    const [total, setTotal] = useState(0);
    const [cptCharges, setCptCharges] = useState('');
    const [editRows, setEditRows] = useState([]);
    const [editableRow, setEditableRow] = useState(null);

    const [box32AData, setBox32AData] = useState([]);
    const [CPTServiceData, setCPTServiceData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
    const [selectDescription, setselectDescription] = useState('');
    const [selectProjectedFee, setselectProjectedFee] = useState('');
    const [selectCharges, setselectCharges] = useState('');
    const [IsDuplicateCPT, setIsDuplicateCPT] = useState([]);

    const [showEnableUnitModal, setShowEnableUnitModal] = useState(false);
    const [showDisableUnitModal, setShowDisableUnitModal] = useState(false);
    const [selectedUnitItem, setSelectedUnitItem] = useState(null);

    useEffect(() => {
        document.title = 'Edit CPT'


        let timerId;

        if (showSuccessModal || showDeleteModal || showConfirmSaveModal) {
            // Start the timer when the success modal is shown
            timerId = setTimeout(() => {
                setShowSuccessModal(false);
                setShowDeleteModal(false);
                setShowConfirmSaveModal(false);
            }, successTimer);
        }


        return () => {
            clearTimeout(timerId);
        };
    }, [showSuccessModal, successTimer, showDeleteModal, showConfirmSaveModal]);







    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };







    const handleToAppointmentDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setAppointmentDate(formattedDate);
            console.log("Selected start date:", formattedDate);
        } else {
            setAppointmentDate(null);
        }
    };






    const handleFromDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);
            console.log("Selected start date:", formattedDate);
        } else {
            setStartDate(null);
        }
    };




    const handleToDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setEndDate(formattedDate);
            console.log("Selected start date:", formattedDate);
        } else {
            setEndDate(null);
        }
    };








    const isValidDate = (dateString) => {
        const regEx = /^\d{4}-\d{2}-\d{2}$/;
        return dateString.match(regEx) !== null;
    };





    const formatDOSDate = (dateString) => {
        if (!dateString) return ''; // Return empty string if dateString is falsy

        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return ''; // Return empty string if date is invalid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    };











    // Fetch CPT list based on user input

    const fetchSearchCPTList = (index, value) => {
        if (!selectedCptValue) {
            setCptValueList([]);
            return;
        }

        console.log('Selected suggestion:', selectedCptValue);

        var inputJSON = {
            PracticeID: userPracticeID,
            SearchKey: selectedCptValue,
        };


        var sJSONInput = JSON.stringify(inputJSON);
        console.log("input of" + CommonAPIConstants.GetAllCPTList, inputJSON);

        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllCPTList}?sInputJSON=${sJSONInput}`;

        console.log("URL: ", url);

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status != 200) {
                    console.log("response.status", response.status);
                } else return response.json();
            })
            .then((data) => {
                const cptData = JSON.parse(data);


                const filteredCPTData = cptData.filter(
                    (item) => `${item.CPTCode} ${item.CPTDesc}` !== selectedCptValue
                );

                setCptValueList(filteredCPTData);
                console.log("filteredCPTData :", filteredCPTData)


            })
            .catch((error) => {
                console.error('Error fetching CPT names:', error);
            });
    };




    useEffect(() => {
        if (!isSuggestionSelected) {
            fetchSearchCPTList(selectedCptValue);
        } else {
            setIsSuggestionSelected(false);
        }
    }, [selectedCptValue]);



    const handleCPTList = (suggestion) => {
        setSelectedCptValue(`${suggestion.CPTCode}`);
        setSelectedCPTCode(`${suggestion.CPTCode}`);
        setCptDescription(`${suggestion.CPTDesc}`)
        setCptCharges(`${suggestion.UnitCharge}`)

        handleCheckIsDuplicateCPT(suggestion.CPTCode)
        setCptValueList([]);
        setSelectedUnitValue(1);
        const billingFee = parseFloat(suggestion.UnitCharge).toFixed(2);
        setSyncedUnitchargeVal(billingFee);
        setSyncedValue(billingFee)
        setIsSuggestionSelected(true);
        console.log('Selected suggestion:', billingFee);
    };


    const handleCPTKeyDown = (e) => {
        if (e.key === 'Backspace') {
            // Handle backspace key
            if (selectedCptValue === '' && cptValueList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setCptValueList([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchSearchCPTList(selectedCptValue.slice(0, -1)) // Remove the last character from searchText

            }
        }
    }




    const resetDialogValues = () => {

        setSelectedCptValue('');
        setCptDescription('');
        setCptCharges('')

    };





    const handleCheckIsDuplicateCPT = async (cptcode) => {


        const inpuJson = {

            sCPTCode: cptcode,
            sPracticeID: userPracticeID,

        }


        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)
        console.log("Input of" + EditCPTConstants.CheckIsDuplicateCPT, inputData);

        try {
            const response = await fetch(APIConstants.BASE_URL_BILLING + EditCPTConstants.CheckIsDuplicateCPT, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();
            setIsDuplicateCPT(responseData)

            if (responseData > 0) {
                setShowSelectErrorModal(true)
            }

            console.log("Response" + EditCPTConstants.CheckIsDuplicateCPT, responseData);


        } catch (error) {
            console.error('An error occurred:', error);
        }
    };




    const handleSaveCPTData = async () => {

        if (IsDuplicateCPT === 1) {
            setShowConfirmSaveModal(true);
            return;
        }

        const inputJson = {

            sPracticeID: userPracticeID,
            sUserID: userId,
            sCPTCode: selectedCptValue,
            sCPTDesc: cptdescription,
            sBillingFee: cptCharges

        }



        const myInput = JSON.stringify(inputJson);
        const sInputJSON = JSON.stringify(myInput);
        console.log("inputRow of" + EditCPTConstants.SaveNewCPTtoList, sInputJSON);


        try {


            const response = await fetch(APIConstants.BASE_URL_BILLING + EditCPTConstants.SaveNewCPTtoList, {
                method: 'POST',


                headers: {

                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },

                body: sInputJSON
            })


            if (response.ok) {
                const responseData = await response.json();

                if (responseData > 0) {
                    setShowSuccessModal(true)

                }


                console.log("RespData of" + EditCPTConstants.SaveNewCPTtoList, responseData);
                handleGetCPTList();
                resetDialogValues();


            } else {
                console.error('Error sending data to the API');

            }





        } catch (error) {
            console.error('An error occurred:', error);

        }

    }






    const handleGetCPTList = () => {

        resetDialogValues()

        setLoading(true);
        var input = {
            PracticeID: userPracticeID
        }

        var sInputJSON = JSON.stringify(input)

        const url = `${APIConstants.BASE_URL_BILLING}${EditCPTConstants.GetPracticeCPTList}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data)

                setTimeout(() => {
                    setLoading(false);
                    setTableDetails(parsedData);
                    setFilteredTableDetails(parsedData);
                }, 100);
                console.log("Response of" + EditCPTConstants.GetPracticeCPTList, parsedData);


            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }




    useEffect(() => {
        if (!hasFetched) {

            handleGetCPTList();
            setHasFetched(true);
        }
    }, [filteredTableDetails, hasFetched])






    const handleGetCPTServiceData = () => {


        var input = {
            PracticeID: userPracticeID
        }

        var sInputJSON = JSON.stringify(input)

        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetCPTServiceData}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data)

                console.log("Response of" + CommonAPIConstants.GetCPTServiceData, parsedData);
                setCPTServiceData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    useEffect(() => {

        handleGetCPTServiceData();

    }, [])







    const handleChangeCPTService = (index, e, item) => {
        const selectedValue = e.target.value
        setSelectedService(selectedValue);
        const updatedRows = [...filteredTableDetails];
        updatedRows[index].ServiceID = selectedValue;
        setFilteredTableDetails(updatedRows);
        handleUpdateCPTServiceData(item, selectedValue)

    };



    // Get the Box32AData

    const handleGetBox32AData = () => {


        var input = {
            PracticeID: userPracticeID
        }

        var sInputJSON = JSON.stringify(input)

        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetBilling32AData}?sJSONInput=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data)

                console.log("Response of" + CommonAPIConstants.GetBilling32AData, parsedData);
                setBox32AData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    useEffect(() => {

        handleGetBox32AData();

    }, [])







    const handleChangeBillingNPI = (index, e, item) => {
        const selectedValue = e.target.value
        setSelectedBillingNPI(selectedValue);
        const updatedRows = [...filteredTableDetails];
        updatedRows[index].Box32a = selectedValue;
        setFilteredTableDetails(updatedRows);
        handleUpdateBox32AData(item, selectedValue)

    };




    const handleGetBox33AData = () => {


        var input = {
            PracticeID: userPracticeID
        }

        var sInputJSON = JSON.stringify(input)

        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetBilling33AData}?sJSONInput=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data)

                console.log("Response of" + CommonAPIConstants.GetBilling33AData, parsedData);
                setCMS33aData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    useEffect(() => {

        handleGetBox33AData();

    }, [])




    const handleCMS33AValue = (index, e, item) => {

        const selectedValue = e.target.value
        setSelectedCMS33a(selectedValue);
        const updatedRows = [...filteredTableDetails];
        updatedRows[index].Box33a = selectedValue;
        setFilteredTableDetails(updatedRows);
        handleUpdateBox33AData(item, selectedValue)
    }





    const handleGetBox33BData = () => {


        var input = {
            PracticeID: userPracticeID
        }

        var sInputJSON = JSON.stringify(input)

        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetBilling33BData}?sJSONInput=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data)

                console.log("Response of" + CommonAPIConstants.GetBilling33BData, parsedData);
                setCMS33bData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    useEffect(() => {

        handleGetBox33BData();

    }, [])


    const handleCMS33BValue = (index, e, item) => {

        const selectedValue = e.target.value
        setSelectedCMS33b(selectedValue);
        const updatedRows = [...filteredTableDetails];
        updatedRows[index].Box33b = selectedValue;
        setFilteredTableDetails(updatedRows);
        handleUpdateBox33BData(item, selectedValue)
    }


    const handleEditRow = (index, item) => {
        setEditableRow(index === editableRow ? null : index);
        setselectDescription(item.CPTDescription)
        setselectProjectedFee(item.ProjectedFee)
        setselectCharges(item.Charges)

    };





    // Update the Box32AData

    const handleUpdateBox32AData = async (item, selectedBillingNPI) => {


        const inpuJson = {

            sFeeId: item.FeeID,
            sBoxValue: selectedBillingNPI,
            sCPTCode: item.CPT,
            sPracticeID: userPracticeID,
            sUserID: userId

        }


        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)
        console.log("Input of" + CommonAPIConstants.UpdateBilling32AData, inputData);

        try {
            const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.UpdateBilling32AData, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();

            console.log("Response" + CommonAPIConstants.UpdateBilling32AData, responseData);


        } catch (error) {
            console.error('An error occurred:', error);
        }
    };



    const handleUpdateBox33AData = async (item, selectedCMS33a) => {


        const inpuJson = {

            sFeeId: item.FeeID,
            sBoxValue: selectedCMS33a,
            sCPTCode: item.CPT,
            sPracticeID: userPracticeID,
            sUserID: userId

        }


        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)
        console.log("Input of" + CommonAPIConstants.UpdateBilling33AData, inputData);

        try {
            const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.UpdateBilling33AData, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();

            console.log("Response" + CommonAPIConstants.UpdateBilling33AData, responseData);


        } catch (error) {
            console.error('An error occurred:', error);
        }
    };



    const handleUpdateBox33BData = async (item, selectedCMS33b) => {


        const inpuJson = {

            sFeeId: item.FeeID,
            sBoxValue: selectedCMS33b,
            sCPTCode: item.CPT,
            sPracticeID: userPracticeID,
            sUserID: userId

        }


        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)
        console.log("Input of" + CommonAPIConstants.UpdateBilling33BData, inputData);

        try {
            const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.UpdateBilling33BData, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();

            console.log("Response" + CommonAPIConstants.UpdateBilling33BData, responseData);


        } catch (error) {
            console.error('An error occurred:', error);
        }
    };




    const handleUpdateCPTServiceData = async (item, selectedService) => {


        const inpuJson = {
            sRoleID: selectedService,
            sFeeId: item.FeeID,
            sCPTCode: item.CPT,
            sPracticeID: userPracticeID,
            sUserID: userId

        }


        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)
        console.log("Input of" + CommonAPIConstants.UpdateCPTServiceData, inputData);

        try {
            const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.UpdateCPTServiceData, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();

            console.log("Response" + CommonAPIConstants.UpdateCPTServiceData, responseData);


        } catch (error) {
            console.error('An error occurred:', error);
        }
    };





    const handleUpdateCPTData = async (item) => {
        const inputJson = {
            sCPTDescription: selectDescription,
            sCPTNewCharge: selectCharges,
            sCPTCode: item.CPT,
            sPracticeID: userPracticeID,
            sProjectedFee: selectProjectedFee,
            sGroupName: "",
            sUserID: userId,
            sBillingFee: Number(item.Charges).toFixed(2)
        };

        const myInput = JSON.stringify(inputJson);
        const sInputJSON = JSON.stringify(myInput);
        console.log("inputRow of " + EditCPTConstants.UpdateCPTtoList, sInputJSON);

        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING + EditCPTConstants.UpdateCPTtoList,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: sInputJSON
                }
            );

            if (response.ok) {
                const responseData = await response.json();



                console.log("RespData of " + EditCPTConstants.UpdateCPTtoList, responseData);

                setEditableRow(null);

                setFilteredTableDetails(prevData =>
                    prevData.map(row =>
                        row.FeeID === item.FeeID
                            ? {
                                ...row,
                                CPTDescription: selectDescription,
                                Charges: selectCharges,
                                ProjectedFee: selectProjectedFee,

                            }
                            : row
                    )
                );
            } else {
                console.error('Error sending data to the API');
            }
        } catch (error) {
            console.error('An error occurred:', error);
        }
    };





    const handleUnitCalculation = async (item, newValue) => {
        const updatedItem = { ...item, UnitCalculation: newValue };

        const inputJson = {
            sFeeID: updatedItem.FeeID,
            sUnitCalculation: newValue,
            sUserID: userId,
            sPracticeID: userPracticeID,
            sCPT: updatedItem.CPT,
        };

        const inputData = JSON.stringify(JSON.stringify(inputJson));
        console.log("Input of " + EditCPTConstants.EditUnitCalculation, inputData);

        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING + EditCPTConstants.EditUnitCalculation,
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: inputData,
                }
            );

            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }

            const responseData = await response.json();
            console.log("Response " + EditCPTConstants.EditUnitCalculation, responseData);


            setFilteredTableDetails(prev =>
                prev.map(row =>
                    row.FeeID === updatedItem.FeeID
                        ? { ...row, UnitCalculation: newValue }
                        : row
                )
            );
        } catch (error) {
            console.error('An error occurred:', error);
        }
    };





    const handleEnableYes = () => {
        if (selectedUnitItem) {
            handleUnitCalculation(selectedUnitItem, 1);
            setShowEnableUnitModal(false);
            setSelectedUnitItem(null);
        }
    };

    const handleDisableYes = () => {
        if (selectedUnitItem) {
            handleUnitCalculation(selectedUnitItem, 0);
            setShowDisableUnitModal(false);
            setSelectedUnitItem(null);
        }
    };


    const handleCloseModals = () => {
        // Close all modals
        setErrorMessage('');
        setShowSelectErrorModal(false);
        setShowConfirmSaveModal(false);
       
        setShowEnableUnitModal(false)
        setShowDisableUnitModal(false)
    };






    // The 200-row scroll loader that used to live here is gone: the table is
    // paginated now, so there is a bounded number of rows on screen by
    // construction and nothing to load on scroll.
    const handleRowClick = (index) => {
        setActiveRow(index);
    };



     useEffect(() => {
         const filteredData = tableDetails.filter(item => {
             const serviceName = CPTServiceData.find(service => service.ServiceID === item.ServiceID)?.ServiceName || '';
             const box32aName = box32AData.find(b => b.NPI === item.Box32a)?.NamewithNPI || '';
             const box33aName = cms33aData.find(b => b.NPI === item.Box33a)?.NamewithNPI || '';
             const box33bName = cms33bData.find(b => b.TaxonomyCode === item.Box33b)?.NamewithTaxCode || '';

             return (
                 String(item.CPT || '').toLowerCase().includes(searchByCPT.toLowerCase()) &&
                 String(item.CPTDescription || '').toLowerCase().includes(searchByDescription.toLowerCase()) &&
                 String(item.ProjectedFee || '').toLowerCase().includes(searchByFee.toLowerCase()) &&
                 String(item.Charges || '').toLowerCase().includes(searchByCharges.toLowerCase()) &&
                 serviceName.toLowerCase().includes(searchByService.toLowerCase()) &&
                 box32aName.toLowerCase().includes(searchByBox32a.toLowerCase()) &&
                 box33aName.toLowerCase().includes(searchByBox33a.toLowerCase()) &&
                 box33bName.toLowerCase().includes(searchByBox33b.toLowerCase())&&
                 String(item.GrpName || '').toLowerCase().includes(searchByGroup.toLowerCase())
             );
         });

         setFilteredTableDetails(filteredData);
     }, [
         searchByCPT,
         searchByDescription,
         searchByFee,
         searchByCharges,
         searchByService,
         searchByBox32a,
         searchByBox33a,
         searchByBox33b,
         searchByGroup,
         tableDetails,
         CPTServiceData,
         box32AData,
         cms33aData,
         cms33bData
     ]);




    const handleSort = (key, accessor) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const sortedData = [...filteredTableDetails].sort((a, b) => {
            let aValue = accessor ? accessor(a) : a[key];
            let bValue = accessor ? accessor(b) : b[key];


            if (aValue == null) aValue = 0;
            if (bValue == null) bValue = 0;


            if (key.toLowerCase().includes('date') || key.toLowerCase().includes('dob') || key.toLowerCase().includes('dos')) {
                aValue = new Date(aValue);
                bValue = new Date(bValue);
            }

            else if (!isNaN(aValue) && !isNaN(bValue)) {
                aValue = parseFloat(aValue) || 0;
                bValue = parseFloat(bValue) || 0;
            }

            else if (typeof aValue === 'string') {
                aValue = aValue.toUpperCase();
                bValue = typeof bValue === 'string' ? bValue.toUpperCase() : '';
            }

            if (aValue < bValue) return direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        setSortConfig({ key, direction });
        setFilteredTableDetails(sortedData);
    };




    // ─────────────────────────────────────────────────────────────────────
    // Counts
    //
    // Every number on this page - the header pills, each tab, the "x-y of z"
    // readout and the totals row - comes from the same two arrays, so none of
    // them can disagree with the rows on screen. Before this, the pill counted
    // the unfiltered list and the readout counted the column-filtered one while
    // the rows came from a third, toolbar-filtered array: pick a Service and the
    // page said "of 214" above eleven rows.
    //
    // baseRows = column filters + toolbar filters, WITHOUT the tab. Each tab's
    // count is therefore exactly what clicking that tab will show.
    // ─────────────────────────────────────────────────────────────────────
    // Distinct groups present in the data that is already loaded. The demo has a
    // Group filter and this page did not; deriving the options avoids inventing
    // a call for a list the rows already carry.
    const groupOptions = useMemo(() => {
        const seen = new Set();
        (tableDetails || []).forEach((r) => { if (r.GrpName) seen.add(r.GrpName); });
        return Array.from(seen).sort((a, b) => String(a).localeCompare(String(b)));
    }, [tableDetails]);

    const baseRows = useMemo(() => {
        let rows = filteredTableDetails || [];
        if (groupFilter) rows = rows.filter((r) => String(r.GrpName || '') === String(groupFilter));
        if (serviceFilter) rows = rows.filter((r) => String(r.ServiceID) === String(serviceFilter));
        if (chargeFilter === 'has') rows = rows.filter((r) => Number(r.Charges) > 0);
        if (chargeFilter === 'none') rows = rows.filter((r) => !Number(r.Charges));
        return rows;
    }, [filteredTableDetails, groupFilter, serviceFilter, chargeFilter]);

    // Switching a tab is a pure re-slice of data already in memory - no refetch,
    // and any in-progress cell edit survives it.
    const viewRows = useMemo(
        () => (tab === 'all' ? baseRows : baseRows.filter((r) => String(r.ServiceID) === String(tab))),
        [baseRows, tab],
    );

    const serviceTabs = useMemo(() => ([
        { key: 'all', label: 'All codes', count: baseRows.length },
        ...(CPTServiceData || []).map((sv) => ({
            key: String(sv.ServiceID),
            label: sv.ServiceName,
            count: baseRows.filter((r) => String(r.ServiceID) === String(sv.ServiceID)).length,
        })),
    ]), [baseRows, CPTServiceData]);

    const zeroCount = useMemo(
        () => viewRows.filter((r) => !Number(r.Charges)).length,
        [viewRows],
    );

    // ── Pagination ───────────────────────────────────────────────────────
    // 20 a page by default. It also settles the scrolling: a bounded page has
    // no need for a capped, separately-scrolling box inside the card.
    const PER_PAGE_OPTIONS = [20, 50, 100, 'All'];
    const [perPage, setPerPage] = useState(20);
    const [page, setPage] = useState(1);

    const pageCount = perPage === 'All'
        ? 1
        : Math.max(1, Math.ceil(viewRows.length / perPage));

    // Any change to what is being listed sends you back to page 1 - otherwise
    // filtering down to 8 rows while on page 6 shows an empty table.
    useEffect(() => {
        setPage(1);
    }, [tab, groupFilter, serviceFilter, chargeFilter, perPage, filteredTableDetails]);

    useEffect(() => {
        if (page > pageCount) setPage(pageCount);
    }, [page, pageCount]);

    const pageRows = useMemo(() => {
        if (perPage === 'All') return viewRows;
        const start = (page - 1) * perPage;
        return viewRows.slice(start, start + perPage);
    }, [viewRows, page, perPage]);

    const pageFrom = viewRows.length === 0 ? 0 : (perPage === 'All' ? 1 : (page - 1) * perPage + 1);
    const pageTo = perPage === 'All' ? viewRows.length : Math.min(page * perPage, viewRows.length);

    // Class for a sortable header label. handleSort is unchanged - this only
    // reflects which column is sorted and which way, which the header never
    // showed. .hv-sort supplies the arrow itself, via ::after.
    const sortCls = useCallback((key) => (
        sortConfig.key !== key
            ? 'hv-sort'
            : `hv-sort is-sorted-${sortConfig.direction === 'asc' ? 'asc' : 'desc'}`
    ), [sortConfig]);

    const ariaSort = useCallback((key) => (
        sortConfig.key !== key
            ? 'none'
            : (sortConfig.direction === 'asc' ? 'ascending' : 'descending')
    ), [sortConfig]);

    // Page buttons with ellipses, so 40 pages do not produce 40 buttons.
    const pageList = useMemo(() => {
        if (pageCount <= 7) return Array.from({ length: pageCount }, (_, i) => i + 1);
        const out = [1];
        const start = Math.max(2, page - 1);
        const end = Math.min(pageCount - 1, page + 1);
        if (start > 2) out.push('start-gap');
        for (let i = start; i <= end; i += 1) out.push(i);
        if (end < pageCount - 1) out.push('end-gap');
        out.push(pageCount);
        return out;
    }, [page, pageCount]);

    const sumOf = useCallback(
    (key) => pageRows.reduce((a, r) => a + (Number(r[key]) || 0), 0),
    [pageRows],
    );

    const handleClearFilters = useCallback(() => {
    setTab('all');
    setGroupFilter('');
    setServiceFilter('');
    setChargeFilter('all');
    setSearchByCPT('');
    setSearchByDescription('');
    setSearchByFee('');
    setSearchByCharges('');
    setSearchByGroup('');
    setSearchByService('');
    setSearchByBox32a('');
    setSearchByBox33a('');
    setSearchByBox33b('');
    }, []);

    // ── Detached horizontal scrollbar ────────────────────────────────────
    // The grid's own bar sits at the bottom of the scrollport, which on a tall
    // table is below the fold: you cannot reach Box 33b without first scrolling
    // past every row. This proxy is pinned in the layout instead, and drives
    // the grid's scrollLeft. The grid keeps overflow-x:auto so trackpad and
    // shift-wheel still work; only its visible bar is hidden.
    const scrollRef = useRef(null);
    const gridWrapRef = useRef(null);
    const barRef = useRef(null);
    const thumbRef = useRef(null);
    const [hasMore, setHasMore] = useState(false);

    useEffect(() => {
    const sc = scrollRef.current;
    const bar = barRef.current;
    const thumb = thumbRef.current;
    if (!sc || !bar || !thumb) return undefined;

    let dragging = false;

    const sync = () => {
    const ratio = sc.clientWidth / sc.scrollWidth;
    const idle = ratio >= 0.999;
    bar.classList.toggle('is-idle', idle);
    setHasMore(!idle && sc.scrollLeft + sc.clientWidth < sc.scrollWidth - 1);
    if (idle) return;
    const w = Math.max(32, bar.clientWidth * ratio);
    const maxLeft = bar.clientWidth - w;
    const maxScroll = sc.scrollWidth - sc.clientWidth;
    thumb.style.width = `${w}px`;
    thumb.style.transform = `translateX(${maxScroll ? (sc.scrollLeft / maxScroll) * maxLeft : 0}px)`;
    };

    const seek = (clientX) => {
    const rect = bar.getBoundingClientRect();
    const w = parseFloat(thumb.style.width) || 32;
    const maxLeft = rect.width - w;
    const x = Math.min(Math.max(clientX - rect.left - w / 2, 0), maxLeft);
    sc.scrollLeft = maxLeft ? (x / maxLeft) * (sc.scrollWidth - sc.clientWidth) : 0;
    };

    const onDown = (e) => { dragging = true; bar.classList.add('is-dragging'); seek(e.clientX); e.preventDefault(); };
    const onMove = (e) => { if (dragging) seek(e.clientX); };
    const onUp = () => { dragging = false; bar.classList.remove('is-dragging'); };

    sync();
    sc.addEventListener('scroll', sync, { passive: true });
    bar.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('resize', sync);
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(sync) : null;
    if (ro) { ro.observe(sc); if (sc.firstElementChild) ro.observe(sc.firstElementChild); }

    return () => {
    sc.removeEventListener('scroll', sync);
    bar.removeEventListener('pointerdown', onDown);
    window.removeEventListener('pointermove', onMove);
    window.removeEventListener('pointerup', onUp);
    window.removeEventListener('resize', sync);
    if (ro) ro.disconnect();
    };
    }, [pageRows.length]);

    return (


        <>

            <div
                className="hv-container hv-page hv-page--dense hv-page--app ecpt"
                style={{ '--hv-top': `${hvTop}px` }}
            >

                <div className="hv-pagehead">
                    <div>
                        <h1 className="hv-pagehead__title">Edit CPT</h1>
                        <p className="hv-pagehead__sub">Fee schedule and CMS-1500 box defaults, by procedure code</p>
                    </div>
                    <div className="hv-pagehead__actions">
                        <span className={zeroCount ? 'hv-pill hv-pill--pending' : 'hv-pill hv-pill--paid'}>
                            {zeroCount ? `${zeroCount} with no charge` : 'Every code has a charge'}
                        </span>
                        <button
                            type="button"
                            className="hv-btn"
                            onClick={() => { setAddOpen(true); setTimeout(() => addCodeRef.current && addCodeRef.current.focus(), 0); }}
                        >
                            Add new CPT
                        </button>
                    </div>
                </div>

                <div className="hv-toolbar">
                    <label className="hv-toolbar__label">
                        Group
                        <select
                            className="hv-select"
                            value={groupFilter}
                            onChange={(e) => setGroupFilter(e.target.value)}
                        >
                            <option value="">All groups</option>
                            {groupOptions.map((g) => (
                                <option key={g} value={g}>{g}</option>
                            ))}
                        </select>
                    </label>

                    <label className="hv-toolbar__label">
                        Service
                        <select
                            className="hv-select"
                            value={serviceFilter}
                            onChange={(e) => setServiceFilter(e.target.value)}
                        >
                            <option value="">All</option>
                            {CPTServiceData.map((s, i) => (
                                <option key={i} value={String(s.ServiceID)}>{s.ServiceName}</option>
                            ))}
                        </select>
                    </label>

                    <label className="hv-toolbar__label">
                        Charge
                        <select
                            className="hv-select"
                            value={chargeFilter}
                            onChange={(e) => setChargeFilter(e.target.value)}
                        >
                            <option value="all">All</option>
                            <option value="has">Has a charge</option>
                            <option value="none">No charge set</option>
                        </select>
                    </label>

                    <div className="hv-search">
                        <input
                            className="hv-input"
                            type="text"
                            placeholder="Search CPT code or description…"
                            value={searchByCPT}
                            onChange={(e) => setSearchByCPT(e.target.value)}
                        />
                    </div>
                </div>

                {/* Add new CPT - collapsed by default. It was a permanently open
                    ~110px panel for three fields, which cost two rows of the grid
                    on every visit to a page you mostly come to read. */}
                <div className={`hv-defaults${addOpen ? ' is-open' : ''}`}>
                    <button type="button" className="hv-defaults__head" onClick={() => setAddOpen((v) => !v)}>
                        <span className="hv-defaults__title">Add new CPT</span>
                        <span className="hv-defaults__summary">
                            Code, description and charge — box defaults can be set afterwards in the row
                        </span>
                        <span className="hv-defaults__caret">▾</span>
                    </button>

                    <div className="hv-defaults__body">
                        <div className="hv-defaults__grid hv-defaults__grid--tight">

                            <div className="hv-field">
                                <span className="hv-field__label hv-req">CPT code</span>
                                <input
                                    ref={addCodeRef}
                                    className="hv-input hv-t-mono"
                                    type='text'
                                    placeholder='CPT'
                                    value={selectedCptValue}
                                    onChange={(e) => setSelectedCptValue(e.target.value)}
                                    onKeyUp={handleCPTKeyDown}
                                    autoComplete="off"
                                />
                                {Array.isArray(cptValueList) && cptValueList.length > 0 && (
                                    <div className="cptsugg-list">
                                        <ul className='cptsugg-list'>
                                            {cptValueList.map((suggestion) => (
                                                <li key={suggestion.val} onClick={() => handleCPTList(suggestion)}>
                                                    {suggestion.CPTCode}-{suggestion.CPTDesc}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>

                            <div className="hv-field" style={{ gridColumn: 'span 2' }}>
                                <span className="hv-field__label hv-req">Description</span>
                                <input
                                    className="hv-input"
                                    type='text'
                                    value={cptdescription}
                                    onChange={(e) => setCptDescription(e.target.value)}
                                />
                            </div>

                            <div className="hv-field">
                                <span className="hv-field__label">Charge</span>
                                <input
                                    className="hv-input"
                                    type='text'
                                    inputMode="decimal"
                                    placeholder='0.00'
                                    value={cptCharges}
                                    onChange={(e) => setCptCharges(e.target.value)}
                                />
                            </div>

                            <div className="hv-field" style={{ alignSelf: 'end' }}>
                                <button type="button" className="hv-btn hv-btn--block" onClick={handleSaveCPTData}>
                                    Save CPT
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

                {loading && (
                    <div className="overlay">
                        <div className="spinner-container">
                            <div className="spinner-grow text-danger" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className="spinner-grow text-warning" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className="spinner-grow text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                )}

                <div className="hv-panel hv-panel--flush">

                    <div className="hv-tabbar hv-tabbar--bar">
                        <span style={{ display: 'flex', gap: 2 }}>
                            {serviceTabs.map((t) => (
                                <button
                                    key={t.key}
                                    type="button"
                                    className={`hv-tabbar__tab${t.key === tab ? ' is-active' : ''}`}
                                    onClick={() => setTab(t.key)}
                                >
                                    {t.label}
                                    {/* The active tab's count is the same number the
                                        readout on the right already states. Badges stay
                                        on the others, where they preview a bucket you
                                        have not opened - that the readout never shows. */}
                                    {t.key !== tab && <span className="hv-tabbar__count">{t.count}</span>}
                                </button>
                            ))}
                        </span>
                        <span className="hv-spacer" />

                        <span className="hv-t-faint">
                            {viewRows.length === 0 ? '0' : `${pageFrom}–${pageTo}`} of {viewRows.length} codes
                        </span>

                        <div className="hv-pagi">
                            <label className="hv-pagi__rows">
                                Rows
                                <select
                                    className="hv-select"
                                    value={String(perPage)}
                                    onChange={(e) => setPerPage(e.target.value === 'All' ? 'All' : Number(e.target.value))}
                                >
                                    {PER_PAGE_OPTIONS.map((n) => (
                                        <option key={String(n)} value={String(n)}>{n}</option>
                                    ))}
                                </select>
                            </label>

                            {pageCount > 1 && (
                                <span className="hv-pagi__pages">
                                    <button
                                        type="button"
                                        className="hv-pagi__btn"
                                        onClick={() => setPage(1)}
                                        disabled={page === 1}
                                        aria-label="First page"
                                    >«</button>
                                    <button
                                        type="button"
                                        className="hv-pagi__btn"
                                        onClick={() => setPage((n) => Math.max(1, n - 1))}
                                        disabled={page === 1}
                                        aria-label="Previous page"
                                    >‹</button>

                                    {pageList.map((n) => (
                                        typeof n === 'number' ? (
                                            <button
                                                key={n}
                                                type="button"
                                                className={`hv-pagi__btn${n === page ? ' is-active' : ''}`}
                                                onClick={() => setPage(n)}
                                                aria-current={n === page ? 'page' : undefined}
                                            >{n}</button>
                                        ) : (
                                            <span key={n} className="hv-pagi__gap">…</span>
                                        )
                                    ))}

                                    <button
                                        type="button"
                                        className="hv-pagi__btn"
                                        onClick={() => setPage((n) => Math.min(pageCount, n + 1))}
                                        disabled={page === pageCount}
                                        aria-label="Next page"
                                    >›</button>
                                    <button
                                        type="button"
                                        className="hv-pagi__btn"
                                        onClick={() => setPage(pageCount)}
                                        disabled={page === pageCount}
                                        aria-label="Last page"
                                    >»</button>
                                </span>
                            )}
                        </div>
                    </div>

                    {pageRows.length === 0 && !loading ? (
                        <div className="hv-empty">
                            <div className="hv-empty__icon"><FontAwesomeIcon icon={faMagnifyingGlass} /></div>
                            <div className="hv-empty__title">No procedure codes match these filters</div>
                            <div className="hv-empty__hint">
                                Nothing here matches the current search. Clear the filters, or add the code you were looking for.
                            </div>
                            <div className="hv-empty__action">
                                <button type="button" className="hv-btn hv-btn--soft" onClick={handleClearFilters}>Clear filters</button>
                                <button type="button" className="hv-btn" onClick={() => setAddOpen(true)}>Add new CPT</button>
                            </div>
                        </div>
                    ) : (

                    <div className={`hv-gridwrap${hasMore ? ' has-more' : ''}`} ref={gridWrapRef}>
                    <div
                        className="hv-table-scroll hv-table-scroll--viewport hv-table-scroll--proxied"
                        ref={scrollRef}
                    >
                    <table
                        className="hv-table hv-table--compact hv-worksheet hv-worksheet--pinned"
                        style={{
                            minWidth: `${COLS.reduce((a, c) => a + c.w, 0)}px`,
                            ...Object.fromEntries(COLS.slice(0, 3).map((c, i) => [`--hv-pin-${i + 1}`, `${c.w}px`])),
                        }}
                    >
                        {/* One source of truth for the widths: COLS feeds the
                            colgroup AND the --hv-pin-N offsets, so the frozen
                            block and the columns can never disagree. */}
                        <colgroup>
                            {COLS.map((c) => <col key={c.key} style={{ width: `${c.w}px` }} />)}
                            <col />
                        </colgroup>

                        <thead>

                            <tr className="hv-grpband">
                                {COLS.slice(0, 3).map((c, i) => (
                                    <th key={c.key} className={`is-frozen hv-pin hv-pin--${i + 1}`}>
                                        {i === 2 ? 'Procedure code' : ''}
                                    </th>
                                ))}
                                <th colSpan={3}>Fee schedule</th>
                                <th colSpan={4} className="is-alt">CMS-1500 defaults</th>
                                <th colSpan={2}>Status</th>
                                <th className="hv-fill" />
                            </tr>

                            <tr>
                                <th className="hv-pin hv-pin--1">#</th>
                                <th className="hv-pin hv-pin--2 is-sortable" onClick={() => handleSort('CPT')} aria-sort={ariaSort('CPT')}>
                                    <span className={sortCls('CPT')}>CPT code</span>
                                </th>
                                <th className="hv-pin hv-pin--3 is-sortable" onClick={() => handleSort('CPTDescription')} aria-sort={ariaSort('CPTDescription')}>
                                    <span className={sortCls('CPTDescription')}>Description</span>
                                </th>
                                <th className="hv-num-col is-sortable" onClick={() => handleSort('ProjectedFee')} aria-sort={ariaSort('ProjectedFee')}>
                                    <span className={sortCls('ProjectedFee')}>Projected fee</span>
                                </th>
                                <th className="hv-num-col is-sortable" onClick={() => handleSort('Charges')} aria-sort={ariaSort('Charges')}>
                                    <span className={sortCls('Charges')}>Charges</span>
                                </th>
                                <th className="is-sortable" onClick={() => handleSort('GrpName')} aria-sort={ariaSort('GrpName')}>
                                    <span className={sortCls('GrpName')}>Group name</span>
                                </th>
                                <th className="is-sortable" onClick={() => handleSort('ServiceID')} aria-sort={ariaSort('ServiceID')}>
                                    <span className={sortCls('ServiceID')}>Service</span>
                                </th>
                                <th className="is-sortable" onClick={() => handleSort('Box32a')} aria-sort={ariaSort('Box32a')}>
                                    <span className={sortCls('Box32a')}>Service facility</span>
                                    <span className="hv-th-sub">Box 32a</span>
                                </th>
                                <th className="is-sortable" onClick={() => handleSort('Box33a')} aria-sort={ariaSort('Box33a')}>
                                    <span className={sortCls('Box33a')}>Billing provider NPI</span>
                                    <span className="hv-th-sub">Box 33a</span>
                                </th>
                                <th className="is-sortable" onClick={() => handleSort('Box33b')} aria-sort={ariaSort('Box33b')}>
                                    <span className={sortCls('Box33b')}>Billing taxonomy</span>
                                    <span className="hv-th-sub">Box 33b</span>
                                </th>
                                <th className="is-sortable" onClick={() => handleSort('UnitCalculation')} aria-sort={ariaSort('UnitCalculation')}>
                                    <span className={sortCls('UnitCalculation')}>Unit calc</span>
                                </th>
                                <th>Action</th>
                                <th className="hv-fill" />
                            </tr>

                            <tr className="hv-table__searchrow">
                                <th />
                                <th><input type='text' placeholder='Search' value={searchByCPT} onChange={(e) => setSearchByCPT(e.target.value)} /></th>
                                <th><input type='text' placeholder='Search' value={searchByDescription} onChange={(e) => setSearchByDescription(e.target.value)} /></th>
                                <th><input type='text' placeholder='Search' value={searchByFee} onChange={(e) => setSearchByFee(e.target.value)} /></th>
                                <th><input type='text' placeholder='Search' value={searchByCharges} onChange={(e) => setSearchByCharges(e.target.value)} /></th>
                                <th><input type='text' placeholder='Search' value={searchByGroup} onChange={(e) => setSearchByGroup(e.target.value)} /></th>
                                <th><input type='text' placeholder='Search' value={searchByService} onChange={(e) => setSearchByService(e.target.value)} /></th>
                                <th><input type='text' placeholder='Search' value={searchByBox32a} onChange={(e) => setSearchByBox32a(e.target.value)} /></th>
                                <th><input type='text' placeholder='Search' value={searchByBox33a} onChange={(e) => setSearchByBox33a(e.target.value)} /></th>
                                <th><input type='text' placeholder='Search' value={searchByBox33b} onChange={(e) => setSearchByBox33b(e.target.value)} /></th>
                                <th />
                                <th />
                                <th className="hv-fill" />
                            </tr>

                        </thead>
                        <tbody>
                            {pageRows.map((item, index) => {
                                const noCharge = !Number(item.Charges);

    return (
                                <Fragment key={index}>
                                <tr
                                    className={[
                                        activeRow === index ? 'is-selected' : '',
                                        noCharge ? 'is-invalid' : '',
                                    ].filter(Boolean).join(' ')}
                                    onClick={() => handleRowClick(index)}
                                >
                                    <td className="hv-pin hv-pin--1"><span className="hv-td-muted">{pageFrom + index}</span></td>

                                    <td className="hv-pin hv-pin--2">
                                        <span className="hv-t-mono hv-t-semi">{item.CPT}</span>
                                    </td>

                                    <td className="hv-pin hv-pin--3">
                                        {editableRow === index ? (
                                            <input type="text" className="hv-cellinput"
                                                value={selectDescription}
                                                onChange={(e) => { markDirty(); setselectDescription(e.target.value); }}
                                            />
                                        ) : (
                                            <span className="hv-td-wrap">{item.CPTDescription}</span>
                                        )}
                                    </td>

                                    <td className="hv-num-col">
                                        {editableRow === index ? (
                                            <input type="number" className="hv-cellinput hv-cellinput--money"
                                                value={selectProjectedFee}
                                                onChange={(e) => { markDirty(); setselectProjectedFee(e.target.value); }}
                                            />
                                        ) : (
                                            Number(item.ProjectedFee).toFixed(2)
                                        )}
                                    </td>

                                    <td className="hv-num-col">
                                        {editableRow === index ? (
                                            <input type="number" className="hv-cellinput hv-cellinput--money"
                                                value={selectCharges}
                                                onChange={(e) => { markDirty(); setselectCharges(e.target.value); }}
                                            />
                                        ) : (
                                            Number(item.Charges).toFixed(2)
                                        )}
                                    </td>

                                    <td>
                                        {item.GrpName
                                            ? item.GrpName
                                            : <span className="hv-t-faint">Not grouped</span>}
                                    </td>

                                    <td>
                                        <select
                                            name="select"
                                            className={`hv-cellselect${isUnset(item.ServiceID) ? ' is-unset' : ''}`}
                                            value={item.ServiceID}
                                            onChange={(e) => { markDirty(); handleChangeCPTService(index, e, item); }}
                                        >
                                            <option value="-1">&lt;--Select--&gt;</option>
                                            {CPTServiceData.map((s, i) => (
                                                <option key={i} value={s.ServiceID}>{s.ServiceName}</option>
                                            ))}
                                        </select>
                                    </td>

                                    <td>
                                        <select
                                            name="select"
                                            className={`hv-cellselect${isUnset(item.Box32a) ? ' is-unset' : ''}`}
                                            value={item.Box32a}
                                            onChange={(e) => { markDirty(); handleChangeBillingNPI(index, e, item); }}
                                        >
                                            <option value="0">&lt;--Select--&gt;</option>
                                            {box32AData.map((b, i) => (
                                                <option key={i} value={b.NPI}>{b.NamewithNPI}</option>
                                            ))}
                                        </select>
                                    </td>

                                    <td>
                                        <select
                                            name="select"
                                            className={`hv-cellselect${isUnset(item.Box33a) ? ' is-unset' : ''}`}
                                            value={item.Box33a}
                                            onChange={(e) => { markDirty(); handleCMS33AValue(index, e, item); }}
                                        >
                                            {cms33aData.map((b, i) => (
                                                <option key={i} value={b.NPI}>{b.NamewithNPI}</option>
                                            ))}
                                        </select>
                                    </td>

                                    <td>
                                        <select
                                            name="select"
                                            className={`hv-cellselect${isUnset(item.Box33b) ? ' is-unset' : ''}`}
                                            value={item.Box33b}
                                            onChange={(e) => { markDirty(); handleCMS33BValue(index, e, item); }}
                                        >
                                            {cms33bData.map((b, i) => (
                                                <option key={i} value={b.TaxonomyCode}>{b.NamewithTaxCode}</option>
                                            ))}
                                        </select>
                                    </td>

                                    {/* Unit calculation. Out of the CPT cell, which was holding
                                        identity and state at once. The field is UnitCalculation,
                                        so the column says that - it is not an active/inactive
                                        flag and labelling it one would misread the data. */}
                                    <td>
                                        <label
                                            className="hv-toggle"
                                            title={item.UnitCalculation == 1 ? 'Unit Calculation is ON' : 'Unit Calculation is OFF'}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <input
                                                type="checkbox"
                                                id={`switchCheckDefault-${item.FeeID}`}
                                                checked={item.UnitCalculation == 1}
                                                onChange={() => {
                                                    setSelectedUnitItem(item);
                                                    item.UnitCalculation == 1
                                                        ? setShowDisableUnitModal(true)
                                                        : setShowEnableUnitModal(true);
                                                }}
                                            />
                                            <span className="hv-toggle__track" />
                                        </label>
                                    </td>

                                    <td>
                                        {editableRow === index ? (
                                            <button className="hv-icon-btn hv-icon-btn--sm" type="button" onClick={() => handleUpdateCPTData(item)} title="Save CPT">
                                                <FontAwesomeIcon icon={faFloppyDisk} />
                                            </button>
                                        ) : (
                                            <button className="hv-icon-btn hv-icon-btn--sm" type="button" onClick={() => handleEditRow(index, item)} title="Edit CPT">
                                                <FontAwesomeIcon icon={faPencil} />
                                            </button>
                                        )}
                                    </td>

                                    <td className="hv-fill" />
                                </tr>

                                {noCharge && (
                                    <tr className="hv-errrow">
                                        <td colSpan={COLS.length + 1}>
                                            <div className="hv-errlist">
                                                <span>No charge set — a claim using {item.CPT} will bill 0.00</span>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                </Fragment>
                                );
                            })}
                        </tbody>

                        <tfoot>
                            <tr className="hv-tr-total">
                                <td className="hv-pin hv-pin--1" />
                                <td className="hv-pin hv-pin--2" />
                                <td className="hv-pin hv-pin--3">Page total — {pageRows.length} {pageRows.length === 1 ? 'row' : 'rows'}</td>
                                <td className="hv-num-col">{sumOf('ProjectedFee').toFixed(2)}</td>
                                <td className="hv-num-col">{sumOf('Charges').toFixed(2)}</td>
                                <td /><td /><td /><td /><td /><td /><td />
                                <td className="hv-fill" />
                            </tr>
                        </tfoot>

                    </table>
                    </div>
                    </div>

                    )}




                    {showSelectErrorModal && (

                        <div className='alertcpt-modal'>
                            <label></label>
                            <button className="hv-icon-btn hv-btn--danger" type="button" onClick={handleCloseModals} title="Close">
                                <FontAwesomeIcon icon={faXmark} />
                            </button>
                            <p>CPT Already Present!!</p>

                        </div>

                    )}



                    {showConfirmSaveModal && (

                        <div className='alertcpt-modal'>
                            <label></label>
                            <button className="hv-icon-btn hv-btn--danger" type="button" onClick={handleCloseModals} title="Close">
                                <FontAwesomeIcon icon={faXmark} />
                            </button>
                            <p>No or Invalid CPT Entry Found...</p>

                        </div>

                    )}



                    {showEnableUnitModal && (
                        <div className='cptunit-modal'>
                            <label></label>
                            <button className="hv-icon-btn hv-btn--danger" type="button" onClick={handleCloseModals} title="Close">
                                <FontAwesomeIcon icon={faXmark} />
                            </button>
                            <p>Are you sure you want to Enable Unit Calculation?</p>
                            <button className='hv-btn' type="button" onClick={handleEnableYes}>Yes</button>
                            <button className='hv-btn hv-btn--ghost' type="button" onClick={handleCloseModals}>No</button>
                        </div>
                    )}

                    {showDisableUnitModal && (
                        <div className='cptunit-modal'>
                            <label></label>
                            <button className="hv-icon-btn hv-btn--danger" type="button" onClick={handleCloseModals} title="Close">
                                <FontAwesomeIcon icon={faXmark} />
                            </button>
                            <p>Are you sure you want to Disable Unit Calculation?</p>
                            <button className='hv-btn' type="button" onClick={handleDisableYes}>Yes</button>
                            <button className='hv-btn hv-btn--ghost' type="button" onClick={handleCloseModals}>No</button>
                        </div>
                    )}



                </div>

                {/* Detached horizontal scrollbar. Pinned in the layout above the
                    action bar, so the right-hand CMS-1500 columns are reachable
                    without first scrolling past every row to find the grid's own
                    bar at the bottom of its scrollport. */}
                <div className="hv-hscroll" ref={barRef}>
                    <div className="hv-hscroll__thumb" ref={thumbRef} />
                </div>

                <div className="hv-actionbar hv-actionbar--fab">
                    <span className="hv-actionbar__count">
                        <strong>{dirtyCount}</strong> unsaved change{dirtyCount === 1 ? '' : 's'}
                    </span>
                    <span className="hv-actionbar__spacer" />
                    <button
                        type="button"
                        className="hv-btn hv-btn--soft"
                        disabled={!dirtyCount}
                        onClick={() => { setDirtyCount(0); handleGetCPTList(); }}
                    >
                        Discard
                    </button>
                    <button
                        type="button"
                        className="hv-btn"
                        disabled={!dirtyCount}
                        onClick={() => handleUpdateCPTData(editRows)}
                    >
                        Save fee schedule
                    </button>
                </div>

            </div>


        </>
    )
}

export default EditCpt
